// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"95588bc1","977":"559d24dc"}[chunkId] + ".chunk.js";
};